<template>
    <div class="container">
        <h1>Configure Integrations</h1>
        <b-table
                v-if="tableData.length > 0"
                :narrowed="true"
                :striped="true"
                :data="tableData"
        >
            <template slot-scope="props">
                <b-table-column label="Name" field="name">
                    <router-link :to="{path: '/configure/integrations/' + props.row.id}">{{props.row.name}}
                    </router-link>
                </b-table-column>
                <b-table-column label="Version" field="version">
                    {{props.row.version}}
                </b-table-column>
                <b-table-column label="Discovered devices" field="discovered_devices" numeric>
                    {{props.row.devices.length}}
                </b-table-column>
                <b-table-column label="Status" centered>{{props.row.status}}</b-table-column>
                <b-table-column label="Enabled" numeric>
                    <b-checkbox v-model="props.row.enableStatus" @input="handleChangeEnabledState(props.row.id)"></b-checkbox>
                </b-table-column>
            </template>
        </b-table>
        <div v-else>No integrations loaded.</div>
        <div class="buttons margin_top_1rem" v-if="hasConfigurePermission(20)">
            <b-button type="is-danger" class="is-small" :disabled="isDisabled()" @click="handleRestart">Restart Engine</b-button>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BTable from "buefy/src/components/table/Table";
  import BCheckbox from "buefy/src/components/checkbox/Checkbox";

  export default {
    name: "screenconfigureintegrations",
    components: {
      BCheckbox,
      BTable,
      BTableColumn
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        prio: 5
      };
    },
    computed: {
      ...mapGetters('integrations', ['integrations', 'discoveredDevicesByIntegration']),
      ...mapGetters('mqtt', ['valueForTopic']),
      ...mapGetters('auth', ['hasPermission', 'restarting']),
      tableData() {
        const data = [];
        this.integrations.forEach(item => {
          let displayedStatus = '-';
          if (typeof this.valueForTopic('live/integrations/' + item.name + '/status/value') !== 'undefined') {
            displayedStatus = parseInt(this.valueForTopic('live/integrations/' + item.name + '/status/value')) === 1 ? 'OK' : 'Failure';
          }

          data.push({
            ...item,
            devices: this.discoveredDevicesByIntegration(item.name),
            status: displayedStatus,
            enableStatus: parseInt(item.enabled) === 1
          });
        });
        return data;
      }
    },
    methods: {
      ...mapActions('auth', ['postRestart']),
      ...mapActions('integrations', ['changeIntegrationEnableState']),
      hasConfigurePermission(permissionId) {
        return this.hasPermission(permissionId);
      },
      isDisabled() {
        return this.restarting;
      },
      handleRestart() {
        if (confirm('Are you sure you want to restart ?')) {
          this.postRestart();
        }
      },
      handleChangeEnabledState(id) {
        const filtered = this.tableData.filter(item => parseInt(item.id) === parseInt(id));
        if (filtered && typeof filtered[0] !== 'undefined') {
          const valueToSend = filtered[0].enableStatus ? 1 : 0;
          this.changeIntegrationEnableState({
            id: id,
            enabled: valueToSend
          });
        }
      }
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>